export default "__VITE_PUBLIC_ASSET__0e1db35e__"